import DispensaryBreadcrumbs from "./DispensaryBreadcrumbs";

export default DispensaryBreadcrumbs;
